import { PASSWORD_RULES } from '../utils/passwordRules';

interface PasswordChecklistProps {
  /** The new password as it is being typed. */
  password: string;
  id?: string;
}

/**
 * The password guidelines, ticked off live as the new password is typed.
 *
 * All six stay listed whatever is typed, so the user can see what is still missing rather than discovering
 * it one refusal at a time. A green check marks a rule met and a red cross one that is not; the state is also
 * spelled out for a screen reader, which cannot see the colour or the glyph.
 */
export function PasswordChecklist({ password, id }: PasswordChecklistProps) {
  return (
    <ul id={id} className="pw-checklist" aria-label="Password requirements">
      {PASSWORD_RULES.map((rule) => {
        const met = rule.test(password);
        return (
          <li
            key={rule.id}
            className={`pw-checklist__item ${met ? 'pw-checklist__item--met' : 'pw-checklist__item--unmet'}`}
          >
            <i
              className={`pi ${met ? 'pi-check-circle' : 'pi-times-circle'} pw-checklist__icon`}
              aria-hidden="true"
            />
            <span>{rule.label}</span>
            <span className="visually-hidden">{met ? ' (met)' : ' (not met)'}</span>
          </li>
        );
      })}
    </ul>
  );
}
